module.exports = __webpack_public_path__ + "static/media/Logo.16e25cdf.svg";